import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  tenants: [],
};

const tenants = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default tenants;
